import * as yup from "yup";

const makeRangeSchema = (fromKey, toKey) => ({
  [fromKey]: yup
    .number()
    .nullable()
    .transform((v, o) => (o === '' ? null : v))
    .min(0, 'From must be at least 0'),
  [toKey]: yup
    .number()
    .nullable()
    .transform((v, o) => (o === '' ? null : v))
    .test('is-greater', 'To must be greater than From', function (value) {
      const from = this.parent[fromKey];
      if (value == null || from == null) return true;
      return value > from;
    }),
});

const validationSchema = yup.object().shape({
  sort_by: yup.string().nullable(),
  drone_types: yup.array().of(yup.string()),
  operational_statuses: yup.string().nullable(),
  ...makeRangeSchema("active_drones_from", "active_drones_to"),
  ...makeRangeSchema("floor_number_from", "floor_number_to"),
  ...makeRangeSchema("drone_box_capacity_from", "drone_box_capacity_to"),
});

export default validationSchema;
